import { type SearchBlockQuery } from 'cms/cms';
import HTMLReactParser from 'html-react-parser';
import { resolveImageFileToImage } from './imageResolver';
import { type ImageFile } from 'cms/cms-types';
import { type SearchItemProps, type SearchItemTagProps } from '4-sections/SearchSection/SearchItem';
import { resolveAncestorToSearchItemTags, resolveContentTypeToSearchItemTags } from './searchItemTagsResolver';
import { type TagsLabelItem } from '4-sections/SearchSection/SearchBlockContext';


export type PageBase = NonNullable<SearchBlockQuery['PageBase']>;
export type PageBaseItems = NonNullable<PageBase['items']>;

export interface SearchItemResolverSettings {
    tagsLabel?: TagsLabelItem[];
    ancestorsTagLabel?: TagsLabelItem[];
}

const getMediaPrefix = (contentType: string[]): string => {
    if (contentType.find(type => {
        return type === 'PdfFile';
    })) {
        return 'pdf.';
    }

    return '';
};

export const resolvePageBaseToSearchItem = (items: PageBaseItems, settings?: SearchItemResolverSettings): SearchItemProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Name, PreviewTitle, PreviewDescription, PreviewImage, ContentType, ContentLink, FileSize, Ancestors } = item as NonNullable<typeof item>;

        let tags: SearchItemTagProps[] = [];
        if (settings?.ancestorsTagLabel) {
            tags = [
                ...tags,
                ...resolveAncestorToSearchItemTags(Ancestors as string[], settings?.ancestorsTagLabel)
            ];
        }

        if (settings?.tagsLabel) {
            tags = [
                ...tags,
                ...resolveContentTypeToSearchItemTags(ContentType as string[], settings?.tagsLabel)
            ];
        }

        const img = resolveImageFileToImage(PreviewImage as ImageFile, '?width=240');

        return {
            ...(ContentLink?.Url && { link: { href: ContentLink.Url } }),
            title: PreviewTitle || Name as string,
            ...(PreviewDescription && { children: HTMLReactParser(PreviewDescription as string) }),
            tags,
            ...(img && { img }),
            subtitle: FileSize ? `(${getMediaPrefix(ContentType as string[])} ${FileSize})` : '',
        };
    });
};
